export const SITE = {
  name: "Djinious Workshop",
  tagline: "From product intent to a GPU-verified digital twin.",
  appUrl: "https://workshop.djinious.xyz",
  description:
    "Djinious Workshop runs your device as a system of functional models and closes the loop through NVIDIA Isaac Sim rigid-body physics on the GPU — one workspace from requirements to a build-ready design.",
} as const;
